/* eslint-disable no-useless-escape */
export const zipPattern = /[A-Za-z]{1,2}[0-9][0-9A-Za-z]?\s?[0-9][A-Za-z]{2}/g;
export const firstOrLastNameValidatorPattern = /^[^!"#$%*+,\/:;<=>?@\[\\\]\^_{|}~]*$/;
export const fixedPhonePattern = /^0[0-68-9]\d{8,9}$/g;
export const houseNrPattern = /^[1-9][0-9]{0,3}$/;
export const mobilePhonePattern = /^07\d{8,9}$/g;
